var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "office-search-form",
      class: { "office-search-form--loading": _vm.loading },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-5 col-lg-4 offset-lg-2" }, [
          _c(
            "label",
            { staticClass: "sr-only", attrs: { for: "workstations" } },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.i18n.workstationsLabel) + "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "office-search-form__input-holder",
              class: {
                "office-search-form__input-holder--invalid":
                  _vm.$v.workstations.$error
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.workstations,
                    expression: "workstations"
                  }
                ],
                staticClass:
                  "office-search-form__input office-search-form__input--ico",
                attrs: {
                  id: "workstations",
                  type: "number",
                  name: "workstations",
                  placeholder: _vm.i18n.workstationsPlaceholder
                },
                domProps: { value: _vm.workstations },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.workstations = $event.target.value
                    },
                    function($event) {
                      return _vm.$v.workstations.$touch()
                    }
                  ]
                }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-5 col-lg-4" }, [
          _c("label", { staticClass: "sr-only" }, [
            _vm._v("\n        " + _vm._s(_vm.i18n.cityLabel) + "\n      ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "office-search-form__input-holder",
              class: {
                "office-search-form__input-holder--invalid":
                  _vm.$v.location.$error
              }
            },
            [
              _vm._t("city-select", null, {
                onChange: _vm.locationSelectOnChange
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-2 col-lg-1" }, [
          _c(
            "button",
            {
              staticClass: "office-search-form__button",
              class: { "button--loading": _vm.loading },
              attrs: { type: "submit", disabled: _vm.loading }
            },
            [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v("\n          " + _vm._s(_vm.i18n.search) + "\n        ")
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }